import { get } from 'lodash';
import isMountedMixin from 'framework/mixins/is-mounted';

/**
 * Handle minor differences between placeholders and plugins and freeze immutable data
 * @param {Object} data - The cms frontend editing data
 * @param {string} type - A type string, `plugin` or `placeholder`
 * @return {Object|Object[]} The frozen array or object
 */
function prepareCmsData(data, type) {
    let frozen = Object.freeze(data);
    return (type === 'plugin') ? [frozen] : frozen;
}

export default {
    mixins: [
        isMountedMixin,
    ],
    props: {
        /** @type {IAbstractPluginContent} */
        content: {
            type: Object,
            default() {
                return {};
            },
        },

        /** @type {IAbstractPlugin[]} */
        plugins: {
            type: Array,
            default() {
                return [];
            },
        },
        cms: Array,
    },
    data() {
        return {
            /** @type {ICmsConfig} */
            cmsCfg: {
                isEditMode: globals.config.cmsEditMode,
                isReady: false,
                type: null,
                classes: null,
                name: null,
                data: null,
            },
        };
    },
    computed: {
        /*
         * Computed check that is successful when all of the following requirements are fulfilled:
         * 1. Client is in edit-mode
         * 2. Component has received the cms registration object
         * 3. Component is mounted
         */
        cmsReady() {
            return this.cmsCfg.isEditMode && this.cmsCfg.isReady && this.isMounted;
        },
        /*
         * Computed property used as a proxy under which to find the cms registration object
         */
        cmsComponentData() {
            return get(this, this.cmsCfg.watchPath);
        },
    },
    watch: {
        /*
         * Handler is executed as soon as `this.cmsReady` resolves to `true`
         */
        cmsReady: {
            /**
             * Property watcher
             * @param {boolean} val - New value
             */
            handler(val) {
                let { name, data, classes, type } = this.cmsCfg;

                if (![val, name, data].every(Boolean)) {
                    return;
                }

                this.$el.classList.add(...classes);
                window.CMS.$(this.$el).data('cms', prepareCmsData(data, type));

                this.$nextTick(() => {
                    window.CMS._plugins.push([name, data]);
                    new window.CMS.Plugin(name, data); // eslint-disable-line no-new
                });
            },
            immediate: true,
        },

        /*
         * Handler is executed as soon as the cms registration object is made available
         */
        cmsComponentData: {
            /**
             * Property watcher
             * @param {ICmsConfig} val - New value
             */
            handler(val) {
                if (!val) {
                    return;
                }

                this.cmsCfg.name = val[0];
                this.cmsCfg.data = val[1];
                this.cmsCfg.classes = [`cms-${ this.cmsCfg.type }`, val[0]];
                this.cmsCfg.isReady = true;
            },
            immediate: true,
        },
    },
};
